import script from "./ProcedureColumn.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProcedureColumn.vue?vue&type=script&setup=true&lang=ts"

import "./ProcedureColumn.vue?vue&type=style&index=0&id=1feb4475&lang=scss"

const __exports__ = script;

export default __exports__
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QList,QItem,QBtn});
